import React from "react";

import {
  DataTableBody,
  DataTableHead,
  DataTableRow,
} from "../../components/Component";
import OlympiadPageTableItems from "./OlympiadPageTableItems";

const OlympiadPageTableBody = ({ users, setUsers }) => {
  const onSelectChange = (e, id) => {
    let newData = users;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].check = e.currentTarget.checked;
    setUsers([...newData]);
  };

  const selectorCheck = (e) => {
    let newData;
    newData = users.map((item) => {
      item.check = e.currentTarget.checked;
      return item;
    });
    setUsers([...newData]);
  };

  return (
    <DataTableBody compact>
      <DataTableHead>
        <DataTableRow className="nk-tb-col-check" noText>
          <div className="custom-control custom-control-sm custom-checkbox notext">
            <input
              type="checkbox"
              className="custom-control-input form-control"
              id="pid-all"
              onChange={(e) => selectorCheck(e)}
            />
            <label className="custom-control-label" htmlFor="pid-all"></label>
          </div>
        </DataTableRow>
        <DataTableRow text="Full Name" />
        <DataTableRow text="Registered Date" />
        <DataTableRow text="Region" />
        <DataTableRow text="School" />
        <DataTableRow text="Year of Study" />
        <DataTableRow text="Phone Number" />
        <DataTableRow text="Olympiad Type" />
        <DataTableRow className="nk-tb-col-tools" noText />
      </DataTableHead>
      {users?.map((item) => {
        return (
          <OlympiadPageTableItems
            key={item?.id}
            item={item}
            onSelectChange={onSelectChange}
          />
        );
      })}
    </DataTableBody>
  );
};

export default OlympiadPageTableBody;
